import React, { FC } from 'react';

import { TableType } from './types';
import styles from './styles.module.css';

export const Table: FC<TableType> = (props) => {
  const { footer, headers, rows, 'data-testid': dataTestId } = props;

  const [headerLeft, headerRight] = headers;

  return (
    <div
      role="table"
      aria-label="Payment schedule"
      className={styles.pairTable}
      data-testid={dataTestId}
    >
      <div role="rowgroup" className={styles.pairTableHeader}>
        <div role="row" className={styles.pairRow}>
          <div
            role="columnheader"
            className={`${styles.pairCell} ${styles.pairCellLeft} ${styles.pairCellHeader}`}
          >
            {headerLeft}
          </div>
          <div
            role="columnheader"
            className={`${styles.pairCell} ${styles.pairCellRight} ${styles.pairCellHeader}`}
          >
            {headerRight}
          </div>
        </div>
      </div>

      <div role="rowgroup" className={styles.pairTableBody}>
        {rows.map((row, idx) => (
          <div role="row" className={styles.pairRow} key={idx}>
            <div
              role="cell"
              className={`${styles.pairCell} ${styles.pairCellLeft}`}
            >
              {row.first}
            </div>
            <div
              role="cell"
              className={`${styles.pairCell} ${styles.pairCellRight}`}
            >
              {row.second}
            </div>
          </div>
        ))}
      </div>

      <div role="rowgroup" className={styles.pairTableFooter}>
        {footer}
      </div>
    </div>
  );
};
